Vue.component('ack-partner-and-distributors', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-partner-and-distributors',
	mixins: [languageMixins],
	created() {
		this.getDistributorsPageDatas();
	},
	data() {
		return {
			pageId: 'partner-and-distributors',
			// origin datas
			partnerAndDistributorsPageDatas: {},
			// page datas
			countries: [],
			regions: [],
			distributors: [],
			supplierTypes: ['Clinic', 'Lab'],
			currentSelected: {
				region: '',
				country: '',
				supplierType: '',
			},
			// map data
			map: null,
			geojson: null,
			selectedCountry: null,
			colors: {
				default: '#e3e3e3',
				hover: '#05adf0',
				selected: '#05adf0',
			},
			selectedRegionOnMap: '',
		};
	},
	methods: {
		getDistributorsPageDatas() {
			fetch(
				'https://s3.us-east-1.amazonaws.com/ackuretta.website/public/translations/ack.data.translations.partner-and-distributors-page.en-US.json',
			)
				.then((response) => response.json())
				.then((datas) => {
					const { countries, regions, distributors } = datas['partner-and-distributors'];
					this.partnerAndDistributorsPageDatas = datas['partner-and-distributors'];
					this.countries = countries;
					this.regions = regions;
					this.distributors = distributors;
				})
				.catch((error) => {
					console.error(error);
				});
		},
		filterCountries(selectedRegion) {
			const filteredCountries = this.partnerAndDistributorsPageDatas.countries.filter(
				(country) => country.region === selectedRegion,
			);
			this.countries = filteredCountries;
		},
		filterDistributors(selected) {
			const distributorsToBeFilter =
				selected.type === 'clinic_or_lab'
					? this.distributors
					: this.partnerAndDistributorsPageDatas.distributors;

			const filteredDistributors = distributorsToBeFilter.filter((distributor) => {
				if (distributor[selected.type]) {
					return distributor[selected.type].includes(selected.value);
				}
			});

			this.distributors = filteredDistributors;
		},
		onRegionSeletorChange(selectedRegion) {
			this.updateCurrentSelects({ region: selectedRegion, country: '', supplierType: '' });
			this.filterCountries(selectedRegion);
			this.filterDistributors({ type: 'region', value: selectedRegion });
			this.showSelectedAreaOnMap(selectedRegion);
		},
		onCountrySeletorChange(selectedCountry) {
			const regionOfSelectedCountry =
				this.countries.find((country) => {
					return country.name === selectedCountry;
				})?.region || '';
			this.updateCurrentSelects({
				region: regionOfSelectedCountry,
				country: selectedCountry,
				supplierType: '',
			});
			this.filterDistributors({ type: 'country', value: selectedCountry });
		},
		onSupplierTypeSeletorChange(selectedSupplierType) {
			this.filterDistributors({ type: 'clinic_or_lab', value: selectedSupplierType });
		},
		splitMultiLinks(linksData) {
			return linksData.split(/[,;\n]+/).map((item) => item.trim());
		},
		// map methods
		initMap() {
			const { web, mobile, zoomDefault } = {
				web: {
					view: 1200,
					zoom: 2,
				},
				mobile: {
					view: 390,
					zoom: 0,
				},
				zoomDefault: 1,
			};

			const devicesZoom =
				window.innerWidth >= web.view
					? web.zoom
					: window.innerWidth > mobile.view
						? zoomDefault
						: mobile.zoom;

			this.map = L.map('map', {
				center: [0, 0],
				zoom: devicesZoom,
				worldCopyJump: false,
				maxBounds: [
					[30, -180],
					[50, 180],
				],
				attributionControl: false,
				zoomControl: true,
				zoomControlPosition: 'topleft',
				boxZoom: false,
				doubleClickZoom: false,
			});

			L.tileLayer('https://stamen-tiles.a.ssl.fastly.net/toner-background/{z}/{x}/{y}.png', {
				attribution: 'Map tiles by Stamen Design',
				noWrap: true,
				bounds: [
					[-60, -180],
					[60, 180],
				],
			}).addTo(this.map);
			this.loadGeoJSON();
		},
		loadGeoJSON() {
			fetch(
				'https://s3.us-east-1.amazonaws.com/ackuretta.rd/Ackuretta+Website/JSON/ack.data.translations.partner-and-distributors-page-geoJSON.en-US.json',
			)
				.then((response) => response.json())
				.then((datas) => {
					this.addGeoJSONLayer(datas.regionsGeoJSON);
				});
		},
		addGeoJSONLayer(countries) {
			L.geoJSON(countries, {
				style: this.setDefaultStyle(),
				onEachFeature: this.onMapEventHandler,
			}).addTo(this.map);
		},
		setDefaultStyle() {
			return {
				fillColor: '#e3e3e3',
				weight: 1,
				opacity: 1,
				color: '#F4F4F4',
				fillOpacity: 0.7,
			};
		},
		showLayerStyle(layer, type) {
			layer.setStyle({
				fillColor: this.colors[type],
				fillOpacity: 0.9,
				weight: 1,
			});
		},
		onMapEventHandler(feature, layer) {
			layer.on({
				mouseover: (e) => this.hoverFeature(e, feature),
				mouseout: (e) => this.resetFeature(e.target),
				click: (e) => this.handleMapClick(e, feature),
			});
		},
		handleMapClick(e, feature) {
			const layer = e.target;
			this.highlightSelectedCountry(layer);
			this.clickMapShowDistributor();
		},
		highlightSelectedCountry(layer) {
			if (this.selectedCountry && this.selectedCountry !== layer) {
				this.showLayerStyle(this.selectedCountry, 'default');
			}
			this.showLayerStyle(layer, 'selected');
			this.selectedCountry = layer;
		},
		hoverFeature(e, feature) {
			const layer = e.target;
			if (layer !== this.selectedCountry) {
				this.showLayerStyle(layer, 'hover');
			}

			layer
				.bindTooltip(feature.properties.name, {
					permanent: true,
					direction: 'center',
					className: 'country-label',
					opacity: 1,
				})
				.openTooltip();
		},
		clickMapShowDistributor() {
			this.selectedRegionOnMap = this.selectedCountry.feature.properties.name;
			this.updateCurrentSelects({
				region: this.selectedRegionOnMap,
				country: '',
				supplierType: '',
			});
			this.filterDistributors({ type: 'region', value: this.selectedRegionOnMap });
			this.filterCountries(this.currentSelected.region);
		},
		resetFeature(layer) {
			if (layer !== this.selectedCountry) {
				this.showLayerStyle(layer, 'default');
			}

			layer.closeTooltip();
		},
		showSelectedAreaOnMap(selectedRegion) {
			this.map.eachLayer((layer) => {
				if (!layer.feature) return;

				const layerRegion = layer.feature.properties.name;
				if (layerRegion === selectedRegion) {
					this.highlightSelectedCountry(layer);
				}
			});
		},
		updateCurrentSelects({ region = '', country = '', supplierType = '' } = {}) {
			this.currentSelected.region = region;
			this.currentSelected.country = country;
			this.currentSelected.supplierType = supplierType;
		},
		isWhatsApp: function (data) {
			return data ? data.toLowerCase().includes('whatsapp') : false;
		},
	},
	computed: {
		groupCountriesForDropdown() {
			return this.countries.reduce((groups, country) => {
				if (country.name === country.region) {
					return groups;
				}
				if (!groups[country.region]) {
					groups[country.region] = [];
				}
				groups[country.region].push(country);
				return groups;
			}, {});
		},
	},
	filters: {
		filterCompanyImageId: function (url) {
			if (url) {
				const id = url.match(/\/d\/(.+?)\/view/)?.[1] || '';
				return `https://drive.google.com/thumbnail?id=${id}`;
			}
		},
		addSocialMediaIcon: function (socialMediaUrl) {
			let iconTypes = {
				facebook: 'fab fa-facebook',
				instagram: 'fab fa-instagram',
				twitter: 'fab fa-twitter',
				whatsapp: 'fab fa-whatsapp',
				linkedin: 'fab fa-linkedin',
				youtube: 'fab fa-youtube',
			};
			for (const [socialMediaType, iconValue] of Object.entries(iconTypes)) {
				if (socialMediaUrl.toLowerCase().includes(socialMediaType)) {
					return iconValue;
				}
			}
		},
	},
	mounted() {
		appLog.log('ack-about-us mounted');
		this.setPageIsLoading(false);
		this.initMap();
	},
	beforeDestroy() {
		this.map?.remove();
	},
});
